export const NEWEST = 'newest'
export const OLDEST = 'oldest'
export const DEFAULT_SORT_ORDER = NEWEST
